// import React, { useState } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import PropTypes from 'prop-types';
import { closeOutageBanner } from './outage-action';

const OutageAlertDisplay = ({
  closeOutageWindow,
}) => {
  const closeAlert = () => {
    closeOutageWindow();
  };
  return (
    <ModalPortal>
      <div
        className="v-f-modal-section cancel-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner outage-alert-banner">
          <div className="cancel-crq-modal-content">
            <p className="login-brand-intro banner-header"><h3 style={{ color: '#FF0000' }}>** IMPORTANT UPDATE ** </h3></p>
            <p>
              <h4> Please be aware that there has been an update regarding the ACE portal.</h4>
            </p>
            <p><h3 style={{ color: '#FF0000' }}>From 30th June 2025, this URL will no longer work.</h3></p>
            <p><h4>Please make sure to use the NEW URL below when accessing the ACE portal.</h4></p>
            <p><a style={{ color: '#0000FF' }} href="https://ace.vodafone.co.uk">https://ace.vodafone.co.uk</a></p>
            <button
              type="button"
              className="login-button"
              onClick={closeAlert}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

OutageAlertDisplay.propTypes = {
  closeOutageWindow: PropTypes.func,
};




const mapDispatchToProps = (dispatch, ownProps) => ({
  closeOutageWindow() {
    dispatch(closeOutageBanner(false));
  },
});

const OutageAlert = connect(
  null,
  mapDispatchToProps,
)(OutageAlertDisplay);

export { OutageAlert };
